import type { IconDefinition } from "@fortawesome/fontawesome-svg-core"
import {
  faEarthAfrica,
  faEarthAmericas,
  faEarthAsia,
  faEarthEurope,
  faEarthOceania,
  faFire,
  faMosque,
} from "@fortawesome/free-solid-svg-icons"

/** Map tên icon lưu dạng string trong visa-countries.json ("icon") sang IconDefinition thật —
 * cho phép thêm/đổi icon nhóm châu lục chỉ bằng cách sửa file json, không cần sửa code, miễn
 * tên icon nằm trong danh sách đã khai báo sẵn ở đây. */
export const VISA_REGION_ICON_MAP: Record<string, IconDefinition> = {
  faFire,
  faEarthAsia,
  faEarthEurope,
  faEarthAmericas,
  faEarthOceania,
  faEarthAfrica,
  faMosque,
}
